{
	"title": "Du behöver logga in",
	"description": "För att visa den här sidan är det nödvändigt att vara inloggad. Logga in. Därefter blir du omdirigerad till den begärda sidan.",
	"primaryButtonTitle": "Öppna inloggning"
}
